var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"color":"error","icon":"warning","value":true}},[_vm._v(" "+_vm._s(_vm.$t('You have no permission to view this page'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }